import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export const DonutChart = ({ color = "primary", data, legend = [] }) => {
  const THEME_COLOR_MAP = {
    primary: "#0066CC",
    secondary: "#D2D2D2",
  };

  const backgroundColor = data.map((_, i) =>
    data.length === 1 ? THEME_COLOR_MAP[color] || "#0066CC" : [THEME_COLOR_MAP.primary, "#BEE1F4"][i % 2]
  );

  const chartData = {
    labels: data.map((d) => d.x),
    datasets: [
      {
        data: data.map((d) => d.y),
        backgroundColor,
        borderWidth: 0,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "80%",
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.raw;
            const label = context.label;
            return `${label}: ${(value * 100).toFixed(0)}%`;
          },
        },
      },
    },
  };

  return (
    <div className="d-flex flex-row align-items-center w-100 p-3 gap-3">
      <div
        className="position-relative w-100"
        style={{
          flex: "0 1 auto",
          aspectRatio: "1 / 1",
          maxWidth: "120px",
        }}
      >
        <Doughnut data={chartData} options={chartOptions} />
      </div>

      <div className="d-flex flex-column gap-1">
        {legend.map((item, i) => (
          <div key={i} className="d-flex align-items-center gap-2">
            <div
              style={{
                width: "16px",
                height: "16px",
                backgroundColor: backgroundColor[i],
              }}
            />
            <span className="fw-bold">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
